import { listProfileBuildingTypeKeys } from "./list-profile-building-type-keys";
const resolveEntryFloorArea = (entry, defaultFloorAreaSquareMetre) => entry.isDefaultFloorArea ? entry.count * defaultFloorAreaSquareMetre : entry.floorAreaSquareMetre;
export function computeFloorAreaSquareMetre({ buildingStock, profile, }) {
    return listProfileBuildingTypeKeys(profile).reduce((sum, buildingType) => sum +
        resolveEntryFloorArea(buildingStock[buildingType], profile.defaultFloorAreaSquareMetreByBuildingType[buildingType]), 0);
}
